// GRID FILTER  ACTIONS:
export const FILTER_SET_PAYLOAD = "FILTER_SET_PAYLOAD";
export const FILTER_SET_VALUES_PAYLOAD = "FILTER_SET_VALUES_PAYLOAD";
export const FILTER_INPUTFIELD_CHANGEHANDLER = "FILTER_INPUTFIELD_CHANGEHANDLER";
export const FILTER_APPLYALL_CHANGEHANDLER = "FILTER_APPLYALL_CHANGEHANDLER";
export const FILTER_REMOVE_FIELD = "FILTER_REMOVE_FIELD";
export const FILTER_NAME_CHANGEHANDLER = "FILTER_NAME_CHANGEHANDLER";
export const FILTER_LOAD_LIST = "FILTER_LOAD_LIST";
export const FILTER_ACTIVE_FILTER = "FILTER_ACTIVE_FILTER";
export const FILTER_SAVE_POPUP = "FILTER_SAVE_POPUP"; 
export const FILTER_ACTIVE_FILTER_AND_PAYLOAD = "FILTER_ACTIVE_FILTER_AND_PAYLOAD";
export const SET_FILTER_AUTO_SUGGESTIONS = "SET_FILTER_AUTO_SUGGESTIONS";
export const FILTER_SET_VALUES_PAYLOAD_CALENDAR = "FILTER_SET_VALUES_PAYLOAD_CALENDAR";
export const SET_FILTER_AUTO_SUGGESTIONS_ACTIVITES = "SET_FILTER_AUTO_SUGGESTIONS_ACTIVITES";
export const CLEAR_PREVIOUS_FILTER='CLEAR_PREVIOUS_FILTER';
    

